import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {BlogState} from '../state/blog.state';
import {CancelSubscription, GetSubscriptionByID} from '../state/blog.actions';
import {FADE_IN} from '../../../shared/animations';
import {MessagesState} from '../../../messages/messages.state';
import {ClearMessages} from '../../../messages/messages.actions';
import { GeneralHeaderComponent } from '../../../layout/header/components/general-header/general-header.component';
import { ExploreYourBrainComponent } from '../../../shared/components/explore-your-brain/explore-your-brain.component';
import { FooterComponent } from '../../../layout/footer/footer.component';


@Component({
    selector: 'app-blog-unsubscribe',
    templateUrl: './blog-unsubscribe.component.html',
    styleUrls: ['./blog-unsubscribe.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN],
    imports: [GeneralHeaderComponent, ExploreYourBrainComponent, FooterComponent]
})
export class BlogUnsubscribeComponent implements OnInit, OnDestroy {
  public readonly newsletterSubscription$ = this.store.select(BlogState.subscription);
  public readonly backendErrors$ = this.store.select(MessagesState.getBackendError);

  subscription = new Subscription();

  isUserUnsubscribed = false;

  id: number = null;
  unsubscribed: boolean = null;
  sign: string = null;
  email: string = null;

  error = null;

  constructor(
    private route: ActivatedRoute,
    protected store: Store,
    protected cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.store.dispatch(new ClearMessages());

    this.subscription.add(
      this.route.queryParams.subscribe(
        params => {
          this.id = +params.id;
          this.unsubscribed = params.unsubscribed === 'True';
          this.sign = params.sign;
          this.email = params.email;

          this.store.dispatch(new GetSubscriptionByID(this.id));
        }
      )
    );

    this.subscription.add(
      this.newsletterSubscription$.pipe(filter(x => !!x)).subscribe(sub => {
        this.isUserUnsubscribed = sub.unsubscribed;
        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.backendErrors$.subscribe(httpError => {
        if (httpError && httpError.error) {
          this.error = httpError.error.detail;
        }
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  cancelSubscription() {
    this.store.dispatch(new CancelSubscription({id: this.id, unsubscribed: this.unsubscribed, sign: this.sign}));
    this.cd.detectChanges();
  }
}
